import axiosInstance from 'api/axiosInstance';

export interface GPDOption {
	Id: number;
	Title: string;
}

export const searchGroups = async (customerId: number, keyword: string): Promise<GPDOption[]> => {
	try {
		const { data } = await axiosInstance.get(
			`/api/cantrackv3/Groups?Id=0&SearchKeyword=${encodeURIComponent(keyword)}&Page=1&Take=999&CustomerId=${customerId}`,
		);
		return Array.isArray(data) ? data : data?.Data || [];
	} catch (error) {
		console.error('[searchGroups] Failed:', error);
		throw error;
	}
};

export const searchProjects = async (groupId: number, keyword: string): Promise<GPDOption[]> => {
	try {
		const { data } = await axiosInstance.get(
			`/api/cantrackv3/Projects?Id=0&SearchKeyword=${encodeURIComponent(keyword)}&Page=1&Take=999&GroupId=${groupId}`,
		);
		return Array.isArray(data) ? data : data?.Data || [];
	} catch (error) {
		console.error('[searchProjects] Failed:', error);
		throw error;
	}
};

export const searchDeliverables = async (projectId: number, keyword: string): Promise<GPDOption[]> => {
	try {
		const { data } = await axiosInstance.get(
			`/api/cantrackv3/Deliverables?Id=0&SearchKeyword=${encodeURIComponent(keyword)}&Page=1&Take=999&ProjectId=${projectId}`,
		);
		return Array.isArray(data) ? data : data?.Data || [];
	} catch (error) {
		console.error('[searchDeliverables] Failed:', error);
		throw error;
	}
};
